import {DropdownMenu} from '@wandb/components';
import React from 'react';

import {useViewAction} from '../../../state/views/hooks';
import * as RunSetActions from '../../../state/views/runSet/actions';
import {TruncationType} from '../../common/TruncateText/TruncateTextTypes';
import {
  useCurrentRunSetRef,
  useRunSetTruncationType,
} from '../RunSelectorRunSetContext';
import type {WBTableColumn} from '../WBTable/types';
import {MenuItem} from './MenuItem';

type RunNameTruncationGroupProps = {
  column: WBTableColumn;
};

export function RunNameTruncationGroup({column}: RunNameTruncationGroupProps) {
  const truncationType = useRunSetTruncationType();
  const runSetRef = useCurrentRunSetRef();
  const updateRunSet = useViewAction(runSetRef, RunSetActions.update);

  if (column.accessor !== 'run:displayName') {
    return null;
  }

  function handleSelectionChange(keys: 'all' | Set<React.Key>) {
    if (keys === 'all') {
      return;
    }
    const [key] = keys;
    if (key) {
      updateRunSet({runNameTruncationType: key as TruncationType});
    }
  }

  return (
    <DropdownMenu.Section
      selectedKeys={[truncationType]}
      selectionMode="single"
      onSelectionChange={handleSelectionChange}>
      <DropdownMenu.Header>Run name cropping</DropdownMenu.Header>
      <MenuItem
        data-dd-action-name="Crop run name end"
        icon="crop-end"
        id={TruncationType.End}>
        Crop the end
      </MenuItem>
      <MenuItem
        data-dd-action-name="Crop run name middle"
        icon="crop-middle"
        id={TruncationType.Middle}>
        Crop the middle
      </MenuItem>
      <MenuItem
        data-dd-action-name="Crop run name beginning"
        icon="crop-beginning"
        id={TruncationType.Beginning}>
        Crop the beginning
      </MenuItem>
    </DropdownMenu.Section>
  );
}
